module.exports = ".noData {\n  color: #FC8F80;\n}"